export const avvKey = '_a_'
export const timelineKey = '_a_t_'
export const stepperKey = '_a_s_'
export const layoutKey = '_a_l_'
export const pageContainerKey = '_a_pc_'
export const fabKey = '_a_f_'
export const formKey = '_a_fo_'
export const tabsKey = '_a_tabs_'
export const uploaderKey = '_a_u_'
